import React, { createContext, useContext, useState, useEffect } from "react";
import apiClient from "../api/apiClient";

// สร้าง Context สำหรับการจัดการสถานะการเข้าสู่ระบบ
const AuthContext = createContext();

// Hook สำหรับใช้งาน AuthContext
export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true); 

  useEffect(() => {
    const fetchUserProfile = async (token) => {
      await apiClient.get("/auth/profile", {headers: { Authorization: `Bearer ${token}` },})
        .then(response => {
            setUser(response.data);
            setIsAuthenticated(true);
        })
        .catch(error => {
            console.error("Error fetching user profile:", error);
            logout(); 
        });

      setLoading(false);
    };

    const token = localStorage.getItem("token");
    setLoading(false);
    if (token) {
      fetchUserProfile(token);
    }
  }, []); 

  const login = (token) => {
    localStorage.setItem('token', token);
    setIsAuthenticated(true);
    apiClient.get("/auth/profile", {headers: { Authorization: `Bearer ${token}` },})
    .then(response => {
      setUser(response.data);
    })
    .catch(error => {
      console.error("Error fetching user profile", error);
      logout();
    });
    setLoading(false);
  };

  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem("token"); // ลบ token ออกจาก localStorage
  };

  // ค่าที่จะให้ใช้งานใน AuthContext
  const value = {
    user,
    isAuthenticated,
    login,
    logout,
  };

  // ให้รอโหลดสถานะก่อนแสดงแอป
  if (loading) {
    return <div>Loading...</div>;
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
